import React, { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import CreateOrEditAmusementGroup from "./CreateOrEdit";
import ChangeOrderAmusementService from "./ChangeOrderAmusementService";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import SwapVert from "@mui/icons-material/SwapVert";
import ChangeOrderAmusementGroup from "./ChangeOrderAmusementGroup";
import { useNavigate } from "react-router-dom";
import GlobalFormControl from "../_Components/GlobalFormControl";

const AmusementGroup = () => {
  const [showModalGroup, setShowModalGroup] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [showModalAmusementsOrder, setShowModalAmusementsOrder] = useState(false);

  const [showModalAmusementGroupOrder, setShowModalAmusementGroupOrder] = useState(false);

  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAmusementGroup.getAll({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    const apiData = await ApiAmusementGroup.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت دسته تفریحات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست دسته های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="mr-2"
              onClick={() => {
                setSelectedGroupId(0);
                setShowModalGroup(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد دسته جدید
            </Button>
            <Button
              variant="success"
              onClick={() => {
                setShowModalAmusementGroupOrder(true);
              }}
            >
              <SwapVert className="mr-1" />
              ترتیب نمایش
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                <div className="">
                  <InputGroup className="mb-3">
                    <Controller
                      name="globalSearch"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <GlobalFormControl
                          type="text"
                          aria-describedby="basic-addon1"
                          placeholder="جستجو ..."
                          name="globalSearch"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />

                    <Button variant="secondary" type="submit" disabled={isSubmitting}>
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </div>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    setShowModalGroup={setShowModalGroup}
                    setSelectedGroupId={setSelectedGroupId}
                    setShowModalAmusementsOrder={setShowModalAmusementsOrder}
                  />
                </Col>
                {showModalGroup && (
                  <CreateOrEditAmusementGroup
                    showModalGroup={showModalGroup}
                    setShowModalGroup={setShowModalGroup}
                    selectedGroupId={selectedGroupId}
                  />
                )}
                {showModalAmusementsOrder && (
                  <ChangeOrderAmusementService
                    showModalAmusementsOrder={showModalAmusementsOrder}
                    setShowModalAmusementsOrder={setShowModalAmusementsOrder}
                    selectedGroupId={selectedGroupId}
                  />
                )}
                {showModalAmusementGroupOrder && (
                  <ChangeOrderAmusementGroup
                    showModalAmusementGroupOrder={showModalAmusementGroupOrder}
                    setShowModalAmusementGroupOrder={setShowModalAmusementGroupOrder}
                  />
                )}
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmusementGroup;
